import { Button } from "antd";
import { Buttons } from "./styles/button.style";
import WithDirection from "../misc/theme/withDirection";

const AntButton = Buttons(Button);
const isoButton = WithDirection(AntButton);

export default isoButton;



// WEBPACK FOOTER //
// ./src/components/ui-ant/elements/button.js